import axios from "axios";
import { handleUnauthorizedResponse } from "../../apiHelper";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";
const GetInitiativeDiscussion = async (IdeaId) => {
  const accessToken = sessionStorage.getItem("access_token");
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const UserID = userdata?.employeeId;

  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeDiscussion`,
      {
        params: { IdeaId, UserID }
      }
    );
    handleUnauthorizedResponse(response);
    console.log("GetInitiativeDiscussion response data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative discussion:", error);
    throw new Error("Failed to fetch initiative discussion");
  }
};

export default GetInitiativeDiscussion;
